import { render, staticRenderFns } from "./DialogAddIncendio.vue?vue&type=template&id=6f2bb67e&scoped=true"
import script from "./DialogAddIncendio.vue?vue&type=script&lang=js"
export * from "./DialogAddIncendio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2bb67e",
  null
  
)

export default component.exports